module.exports = __webpack_public_path__ + "img/completed.50106f49.svg";